// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  TrafficWaitTimeListResponse,
  TrafficWaitTimeListResponseT,
  verifyTrafficWaitTimeListResponse,
} from "./traffic-wait-time-list-response";

export class TrafficWaitTimeListResponses implements flatbuffers.IUnpackableObject<TrafficWaitTimeListResponsesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TrafficWaitTimeListResponses {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTrafficWaitTimeListResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficWaitTimeListResponses,
  ): TrafficWaitTimeListResponses {
    return (obj || new TrafficWaitTimeListResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsTrafficWaitTimeListResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficWaitTimeListResponses,
  ): TrafficWaitTimeListResponses {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TrafficWaitTimeListResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  results(index: number, obj?: TrafficWaitTimeListResponse): TrafficWaitTimeListResponse | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new TrafficWaitTimeListResponse()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  resultsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startTrafficWaitTimeListResponses(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addResults(builder: flatbuffers.Builder, resultsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, resultsOffset, 0);
  }

  static createResultsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startResultsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endTrafficWaitTimeListResponses(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // results
    return offset;
  }

  static createTrafficWaitTimeListResponses(
    builder: flatbuffers.Builder,
    resultsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    TrafficWaitTimeListResponses.startTrafficWaitTimeListResponses(builder);
    TrafficWaitTimeListResponses.addResults(builder, resultsOffset);
    return TrafficWaitTimeListResponses.endTrafficWaitTimeListResponses(builder);
  }

  unpack(): TrafficWaitTimeListResponsesT {
    return new TrafficWaitTimeListResponsesT(
      this.bb!.createObjList<TrafficWaitTimeListResponse, TrafficWaitTimeListResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      ),
    );
  }

  unpackTo(_o: TrafficWaitTimeListResponsesT): void {
    _o.results = this.bb!.createObjList<TrafficWaitTimeListResponse, TrafficWaitTimeListResponseT>(
      this.results.bind(this),
      this.resultsLength(),
    );
  }

  unpackFields(...fields: string[]): TrafficWaitTimeListResponsesT {
    const t = new TrafficWaitTimeListResponsesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("results")) {
      t.results = this.bb!.createObjList<TrafficWaitTimeListResponse, TrafficWaitTimeListResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      );
    }
    return t;
  }
}

export class TrafficWaitTimeListResponsesT implements flatbuffers.IGeneratedObject {
  constructor(public results: TrafficWaitTimeListResponseT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.results === null || this.results === undefined) {
      throw new Error('Required field "results" is not set');
    }
    const results = TrafficWaitTimeListResponses.createResultsVector(
      builder,
      builder.createObjectOffsetList(this.results),
    );

    return TrafficWaitTimeListResponses.createTrafficWaitTimeListResponses(builder, results);
  }

  clone(): TrafficWaitTimeListResponsesT {
    const obj = new TrafficWaitTimeListResponsesT();
    obj.results = this.results.map((e) => e.clone());
    return obj;
  }

  equals(other: TrafficWaitTimeListResponsesT): boolean {
    if (this.results.length !== other.results.length) return false;
    for (let i = 0; i < this.results.length; i++) {
      const a = this.results[i];
      const b = other.results[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyTrafficWaitTimeListResponses(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyTrafficWaitTimeListResponse);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "results");
  } finally {
    verifier.popDepth();
  }
}
